import {HorizontalList} from 'focus-manager/web';
import * as React from 'react';

import ArrowRight from '../Icons/RightArrow';
import FormState from '../Models/FormState';

import Button from './Button';
import ScalableText from './ScalableText';

interface IFormNavigatorProps {
    formState: FormState;
    onPrevSelect: () => void;
    onNextSelect: () => void;
}

const FormNavigator: React.FC<IFormNavigatorProps> = ({formState, onPrevSelect, onNextSelect}) => (
    <HorizontalList className="key-wrapper key-wrapper--detached" loop>
        <Button basis={35} isUpperCased disableFocus={!formState.canGoBack} onSelect={onPrevSelect}>
            <ScalableText>Previous</ScalableText>
        </Button>
        <Button basis={65} isUpperCased onSelect={onNextSelect} anchors={[15, 50, 80]}>
            <ScalableText>Next</ScalableText>
            <ArrowRight />
        </Button>
    </HorizontalList>
);

export default FormNavigator;
